import React, {Component} from 'react';
import {Form, Input, Modal} from 'antd';
import PropTypes from 'prop-types';
import { app } from "../app"

class ReviewFailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible,
            submit_loading: false,
            reviewInfo:'',
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }


    /**
     * 设置值
     * @param obj
     */
    setData = (obj) => app.setStateSync(this, obj)

    /**
     * 审核结果
     * @param rule
     * @param value
     * @param callback
     */
    handleReviewResult = (rule, value, callback) => {
        if (value && value.trim() === '') {
            callback('请输入审核失败原因！');
        }
        callback();
    }

    /**
     * 提交意见
     * @param e
     */
    handleSubmitIdea = (e) => {
        e.preventDefault();
        let {form, submit} = this.props;
        form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    await this.setData({submit_loading: true})
                    await submit(values.detail);
                } catch (e) {} finally {
                    await this.setData({submit_loading: false})
                }
            }
        });
    }

    CloseReviewModal = () => {
        this.props.close();
    }

    componentWillReceiveProps(props) {
        const {visible} = props;

        if(visible){
            let {reviewInfo} = this.state;
            reviewInfo = props.reviewInfo
            this.setState({reviewInfo});
        }
        if (this._isMounted && this.state.visible !== visible) {
            this.setState({visible});
        }
    }

    render() {
        let {visible, submit_loading,reviewInfo} = this.state,
            {form, label, zhu} = this.props,
            {getFieldDecorator} = form;
        return (
            <Modal
                visible={visible}
                onOk={this.handleSubmitIdea}
                onCancel={this.CloseReviewModal}
                okText="确定"
                cancelText="取消"
                title="买家留言"
                maskClosable={false}
                keyboard={false}
                confirmLoading={submit_loading}
                style={{top: "30%"}}
            >
                <Form>
                    {getFieldDecorator('audit', {initialValue: 2})(
                        <Input type="hidden"/>
                    )}
                    <Form.Item
                        label={label}
                        labelCol={{span: 5}}
                        wrapperCol={{span: 18, offset: 1}}
                    >
                        {getFieldDecorator('detail', {
                            rules: [
                                {required: true, message: '请输入买家留言!'},
                                {validator: this.handleReviewResult}
                            ],
                            initialValue:reviewInfo // 设置初始值
                        })(
                            <Input.TextArea autosize={{minRows: 4, maxRows: 10}}/>
                        )}
                    </Form.Item>
                    <span style={{color: 'red'}} hidden={!zhu}>{zhu}</span>
                </Form>
            </Modal>
        );
    }
}

ReviewFailModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    submit: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    // label: PropTypes.Any,
    // zhu: PropTypes.Any,
};

export default Form.create()(ReviewFailModal);



// WEBPACK FOOTER //
// ./src/components/MMOrderModal.jsx